
import { SVGProps } from "react";
const LockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={64}
    height={64}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={32} cy={32} r={31.5} fill="white" stroke="rgb(var(--pd-rule))" />
    <path
      d="M38.016 29.448V26.6161C38.016 23.3001 35.32 20.6001 32 20.6001C28.684 20.6001 25.9839 23.3001 25.9839 26.6161V29.448C24.5959 29.564 23.5039 30.736 23.5039 32.1519V35.5281C23.5039 39.868 27.0319 43.4001 31.3719 43.4001H32.6278C36.9678 43.4001 40.4958 39.868 40.4958 35.5281V32.1519C40.4958 30.7359 39.404 29.564 38.016 29.448ZM28.588 26.6161C28.775 22.0951 35.2251 22.0962 35.4119 26.6161V29.4362H28.588L28.588 26.6161ZM31.048 36.7323C29.644 35.8163 30.329 33.5773 32 33.5922C33.671 33.5782 34.357 35.8152 32.952 36.7323C32.844 36.8043 32.776 36.9323 32.776 37.0643V38.4683C32.75 39.4903 31.251 39.4923 31.224 38.4683V37.0643C31.224 36.9323 31.156 36.8043 31.048 36.7323Z"
      fill="rgb(var(--pd-rule))"
    />
  </svg>
);
export default LockIcon;
